// src/utils/axiosInstance.js

import axios from 'axios';

// Set the base URL dynamically depending on the environment
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:1000';

// Create a reusable axios instance
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor (optional)
axiosInstance.interceptors.request.use(
  (config) => {
    // Add Authorization header if the user is logged in (e.g., token from Redux)
    const token = localStorage.getItem('token') || ''; // or use Redux state
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor (optional)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
